import {
  ReadonlyBaseballPlayerToken,
  ReadonlyBasketballPlayerToken,
  ReadonlyCricketPlayerToken,
  ReadonlyIceHockeyPlayerToken,
  ReadonlyRugbyPlayerToken,
  ReadonlySoccerPlayerToken,
  ReadonlyToken,
  ReadonlyVolleyballPlayerToken,
  TokenType,
  TokenVisitor,
} from "@sportactics/board-editing";

import { AnalyticsEventToken } from "./analytics-event-token";

export function convertTokenToAnalyticsEvent(
  token: ReadonlyToken,
): AnalyticsEventToken {
  return AnalyticsEventTokenConverter.getInstance().visit(token);
}

class AnalyticsEventTokenConverter extends TokenVisitor<AnalyticsEventToken> {
  private static readonly instance = new AnalyticsEventTokenConverter();

  static getInstance(): AnalyticsEventTokenConverter {
    return this.instance;
  }

  protected visitVolleyballBall(): AnalyticsEventToken {
    return { type: TokenType.VolleyballBall };
  }

  protected visitVolleyballPlayer(
    token: ReadonlyVolleyballPlayerToken,
  ): AnalyticsEventToken {
    return {
      type: TokenType.VolleyballPlayer,
      team: token.team,
      role: token.role,
    };
  }

  protected visitBasketballBall(): AnalyticsEventToken {
    return { type: TokenType.BasketballBall };
  }

  protected visitBasketballPlayer(
    token: ReadonlyBasketballPlayerToken,
  ): AnalyticsEventToken {
    return {
      type: TokenType.BasketballPlayer,
      team: token.team,
      position: token.playerPosition,
    };
  }

  protected visitSoccerBall(): AnalyticsEventToken {
    return { type: TokenType.SoccerBall };
  }

  protected visitSoccerPlayer(
    token: ReadonlySoccerPlayerToken,
  ): AnalyticsEventToken {
    return {
      type: TokenType.SoccerPlayer,
      team: token.team,
      position: token.playerPosition,
    };
  }

  protected visitIceHockeyPuck(): AnalyticsEventToken {
    return { type: TokenType.IceHockeyPuck };
  }

  protected visitIceHockeyPlayer(
    token: ReadonlyIceHockeyPlayerToken,
  ): AnalyticsEventToken {
    return {
      type: TokenType.IceHockeyPlayer,
      team: token.team,
      position: token.playerPosition,
    };
  }

  protected visitRugbyBall(): AnalyticsEventToken {
    return { type: TokenType.RugbyBall };
  }

  protected visitRugbyPlayer(
    token: ReadonlyRugbyPlayerToken,
  ): AnalyticsEventToken {
    return {
      type: TokenType.RugbyPlayer,
      team: token.team,
      position: token.playerPosition,
    };
  }

  protected visitBaseballBall(): AnalyticsEventToken {
    return { type: TokenType.BaseballBall };
  }

  protected visitBaseballPlayer(
    token: ReadonlyBaseballPlayerToken,
  ): AnalyticsEventToken {
    return {
      type: TokenType.BaseballPlayer,
      position: token.playerPosition,
    };
  }

  protected visitCricketBall(): AnalyticsEventToken {
    return { type: TokenType.CricketBall };
  }

  protected visitCricketPlayer(
    token: ReadonlyCricketPlayerToken,
  ): AnalyticsEventToken {
    return { type: TokenType.CricketPlayer, team: token.team };
  }

  protected visitCustomPlayer(): AnalyticsEventToken {
    return { type: TokenType.CustomPlayer };
  }

  protected visitCone(): AnalyticsEventToken {
    return { type: TokenType.Cone };
  }

  protected visitFlag(): AnalyticsEventToken {
    return { type: TokenType.Flag };
  }

  protected visitHoop(): AnalyticsEventToken {
    return { type: TokenType.Hoop };
  }

  protected visitHurdle(): AnalyticsEventToken {
    return { type: TokenType.Hurdle };
  }

  protected visitPole(): AnalyticsEventToken {
    return { type: TokenType.Pole };
  }

  protected visitPlainColor(): AnalyticsEventToken {
    return { type: TokenType.PlainColor };
  }
}
